<template>
  <b-row class="g-4">
    <b-col cols="12" class="w-100">
      <b-overlay
        :show="loading"
        variant="primary"
        :opacity="0.2"
        rounded="sm"
        style="min-height: 200px"
      >
        <div v-show="info.address">
          <div class="google-map" ref="googleMapGeocoder" style="height: 300px"></div>
        </div>
        <b-img-lazy v-if="!info.address" :src="require(`@/assets/img/banner/slide-3.jpg`)" class="object-fit-cover w-100" alt="ABA Job" style="height: 30rem;" />
      </b-overlay>
    </b-col>
    <div class="col-3">
<!--      <b-img-lazy :src="require(`@/assets/img/logo-ABA.svg`)" class="img img-fluid w-100 mb-4" />-->
      <p class="mb-2">
        <span class="fw-bold" v-html="info.firmname"></span><br />
        <span v-if="info.address">{{ info.address }}</span> <br />
        <span v-if="info.plz">{{ info.plz }}</span>&nbsp;
        <span v-if="info.ort">{{ info.ort }}</span>
      </p>
      <p class="mb-0" v-if="info.phone">
        <b-icon icon="telephone" class="mr-2" />
        <a :href="`tel:${info.phone}`">{{ info.phone }}</a>
      </p>
      <p class="mb-0" v-if="info.fax">
        <b-icon icon="printer" class="mr-2" />
        <a :href="`tel:${info.fax}`">{{ info.fax }}</a>
      </p>
      <p class="mb-0" v-if="info.email">
        <b-icon icon="envelope" class="mr-2"></b-icon>
        <a :href="`mailto:${info.email}`">{{ info.email }}</a>
      </p>
      <p>
        <b-icon icon="globe2" class="mr-2"></b-icon>
        <a href="#" @click.prevent="{}" target="_blank">-</a></p>
      <p>
        <span class="fw-bold">Ihre Ansprechpartnerin:</span>
        <br>Franziska Franz
        <br><b-icon icon="envelope" class="mr-2"></b-icon>karriere@RETRO Logistics AG</p>
    </div>
    <div class="col-9">
      <h1 class="display-4">{{ info.firmname }}</h1>
      <p class="lead fw-bold lh-sm">-</p>
      <p></p>
    </div>
  </b-row>
</template>

<script lang="ts">
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { ICompanyInfo } from '@/types/CompanyType';
import { Loader } from '@googlemaps/js-api-loader';
import { GOOGLE_MAP_KEY } from '@/config/constant';
import { CompanyModule } from '@/store/modules/company';

@Component
export default class CompanyInfo extends Vue {
  get info():ICompanyInfo {
    return CompanyModule.companyItem;
  }

  google: any = null;

  map: any;

  geocoder: any = null;

  marker: any = null;

  loading = false;

  get translations() {
    return AppModule.translation;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  clearMarker() {
    this.marker.setMap(null);
  }

  set_direction() {
    if (this.marker !== null) {
      this.clearMarker();
    }
    this.geocoder.geocode({ address: this.info.address }, (results: any[], status: any) => {
      if (status === this.google.maps.GeocoderStatus.OK) {
        this.map.setCenter(results[0].geometry.location);
        // eslint-disable-next-line
        this.marker.setPosition(results[0].geometry.location);
        this.marker.setMap(this.map);
      } else {
        console.error(`${status}`);
      }
    });
  }

  initializeMap() {
    this.geocoder = new this.google.maps.Geocoder();
    this.map = new this.google.maps.Map(this.$refs.googleMapGeocoder, {
      scrollwheel: false,
      zoom: 15,
      mapTypeId: this.google.maps.MapTypeId.ROADMAP,
      // center: { lat: 13.14, lng: 47.66 },
    });
    this.marker = new this.google.maps.Marker({
      map: this.map,
    });
    this.set_direction();
  }

  async getCompanyInfo() {
    this.loading = true;
    await CompanyModule.GetCompanyItem({
      sid: this.languageSid,
    });
    this.loading = false;
    this.googleCreate();
  }

  googleCreate() {
    if (this.info.address) {
      const loader = new Loader({
        apiKey: GOOGLE_MAP_KEY,
      });
      loader
        .load()
        .then((google) => {
          this.google = google;
          this.initializeMap();
        });
    }
  }

  created() {
    this.getCompanyInfo();
  }
}
</script>
<style scoped lang="scss"></style>
